var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"mainContainer"},[_c('div',[(_vm.doWeWantParticles)?_c('ParticleJS',{staticClass:"particlesStyling",attrs:{"themeColor":_vm.themingColor}}):_vm._e()],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }